export const WEBVIEW_TOKEN_STORAGE_KEY = "stationElementsWebviewToken";

const normalizeToken = (token) => {
  const value = Array.isArray(token) ? token[0] : token;
  return typeof value === "string" ? value.trim() : "";
};

export const readIncomingWebviewToken = (query = {}) => {
  const queryToken = normalizeToken(query.token);
  if (queryToken) return queryToken;

  const hash = window.location.hash.replace(/^#/, "");
  return normalizeToken(new URLSearchParams(hash).get("token"));
};

export const storeWebviewToken = (token) => {
  const value = normalizeToken(token);
  if (!value) return false;

  try {
    sessionStorage.setItem(WEBVIEW_TOKEN_STORAGE_KEY, value);
    return true;
  } catch (error) {
    console.warn("WebView Token 写入失败", error);
    return false;
  }
};

export const getWebviewToken = () => {
  try {
    return sessionStorage.getItem(WEBVIEW_TOKEN_STORAGE_KEY) || "";
  } catch (error) {
    console.warn("WebView Token 读取失败", error);
    return "";
  }
};

export const clearWebviewToken = () => {
  try {
    sessionStorage.removeItem(WEBVIEW_TOKEN_STORAGE_KEY);
  } catch (error) {
    console.warn("WebView Token 清除失败", error);
  }
};

export const removeTokenFromAddressBar = () => {
  const url = new URL(window.location.href);
  let changed = false;

  if (url.searchParams.has("token")) {
    url.searchParams.delete("token");
    changed = true;
  }

  const hashParams = new URLSearchParams(url.hash.replace(/^#/, ""));
  if (hashParams.has("token")) {
    hashParams.delete("token");
    url.hash = hashParams.toString() ? `#${hashParams.toString()}` : "";
    changed = true;
  }

  if (changed) {
    window.history.replaceState(
      window.history.state,
      "",
      `${url.pathname}${url.search}${url.hash}`
    );
  }
};
